import React from 'react';

function HeartIcon({ className, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M11.1247 16.9226C10.4914 17.4976 9.51637 17.4976 8.88303 16.9143L8.79137 16.831C4.41637 12.8726 1.55803 10.281 1.66637 7.04764C1.71637 5.63097 2.44137 4.27264 3.61637 3.47264C5.81637 1.97264 8.53303 2.67264 9.9997 4.38931C11.4664 2.67264 14.183 1.96431 16.383 3.47264C17.558 4.27264 18.283 5.63097 18.333 7.04764C18.4497 10.281 15.583 12.8726 11.208 16.8476L11.1247 16.9226Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default HeartIcon;
